import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { getCashHistoryApi, updateCashHistoryApi } from '@src/api/cash';
import { CashHistoryParams } from '@src/api/cash/cash';
import { refundPaymentByIdApi } from '@src/api/payment';
import { PaymentRefundParams } from '@src/api/payment/payment';

export const getCashHistory = createAsyncThunk(
  'credits/getCashHistory',
  async (params: CashHistoryParams, { rejectWithValue }) => {
    try {
      const response = await getCashHistoryApi(params);
      return response.result.data;
    } catch (error) {
      throw rejectWithValue(error);
    }
  }
);

export const updateCashHistory = createAsyncThunk(
  'credits/updateCashHistory',
  async (data: { creditId: string; note: string }, { rejectWithValue }) => {
    try {
      const { creditId, ...params } = data;
      const response = await updateCashHistoryApi(creditId, params);
      return response.result;
    } catch (error) {
      throw rejectWithValue(error);
    }
  }
);

export const refundCash = createAsyncThunk(
  'payment/refund',
  async (data: PaymentRefundParams, { rejectWithValue }) => {
    try {
      await refundPaymentByIdApi(data);
    } catch (error) {
      if (axios.isAxiosError(error)) {
        throw rejectWithValue(error.response?.data);
      }
    }
  }
);
